import styled from 'styled-components';

export const Wrapper = styled.div`
  height: 100vh;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  > div {
    max-width: 580px;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 32px;
    flex-grow: 1;
    font-size: 20px;
    font-style: normal;
    font-weight: 500;
    color: ${({ theme }) => theme.color.grey900};
    line-height: 140%;

    span {
      font-weight: 700;
    }

    svg {
      min-width: 60px;
      min-height: 64px;
    }
  }

  button {
    width: fit-content;
  }
`;
